export function buildExportTimestamp(now: Date = new Date()): string {
  return now
    .toLocaleString()
    .replace(/[/,:]/g, '_')
    .replace(/\s/g, '_')
    .replace(/\./g, '');
}

export function buildExportFilename(
  exportName: string,
  now: Date = new Date(),
  extension = 'csv',
): string {
  return `${exportName}_export_${buildExportTimestamp(now)}.${extension}`;
}
